var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-notification__wrapper"},_vm._l((_vm.notifications),function(notification){return _c('NotificationEntry',{key:notification.id,attrs:{"notification":notification}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }